import React from 'react';
import './KioskoComponents.css';

const BotonKiosko = ({ texto, color = 'blue', onClick, tamano = 'grande' }) => {
    return (
        <button
            className={`btn-kiosko btn-kiosko-${color} btn-kiosko-${tamano}`}
            onClick={onClick}
        >
            {texto}
        </button>
    );
};

export default BotonKiosko;
